export function createEditAnswerLink(bookId, questionId, answerId) {
  const url = `/dashboard/book/${bookId}/stories/view/pending?question=${questionId}&answer=${answerId}&is_edit=true`
  return url
}

export function createViewAnswerLink(bookId, questionId, answerId) {
  let url = `/dashboard/book/${bookId}/stories/view/pending?question=${questionId}`
  if (answerId) {
    return url + `&answer=${answerId}`
  }

  return url
}
